import { Route } from "react-router-dom";
import { RedirectIfAuthenticated } from "../auth/Guard";
import { PRIVACY_PATH, TERMS_PATH } from "../legal/legal";
import ConfirmEmailPage from "../pages/account/ConfirmEmailPage/ConfirmEmailPage";
import LegalPage from "../pages/legal/LegalPage/LegalPage";
import EnrollMfaPage from "../pages/login/EnrollMfaPage/EnrollMfaPage";
import ForgotPasswordPage from "../pages/login/ForgotPasswordPage/ForgotPasswordPage";
import LoginPage from "../pages/login/LoginPage/LoginPage";
import MfaPage from "../pages/login/MfaPage/MfaPage";
import PrivacyPage from "../pages/login/PrivacyPage/PrivacyPage";
import SetPasswordPage from "../pages/login/SetPasswordPage/SetPasswordPage";

/** The sign-in flow and the pages anyone can open without a session. */
export function signedOutRoutes(): React.JSX.Element {
  return (
    <>
      <Route
        path="/login"
        element={
          <RedirectIfAuthenticated>
            <LoginPage />
          </RedirectIfAuthenticated>
        }
      />
      <Route path="/login/mfa" element={<MfaPage />} />
      <Route path="/login/enroll-mfa" element={<EnrollMfaPage />} />
      <Route path="/login/privacy" element={<PrivacyPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/invite" element={<SetPasswordPage />} />
      <Route path="/reset-password" element={<SetPasswordPage />} />
      {/* Public: opened from the email, maybe on a phone without a session. */}
      <Route path="/account/confirm-email" element={<ConfirmEmailPage />} />
      {/* Public: readable before signing in, and from the footer once signed in. */}
      <Route path={PRIVACY_PATH} element={<LegalPage document="privacy" />} />
      <Route path={TERMS_PATH} element={<LegalPage document="terms" />} />
    </>
  );
}
